import { render } from "./AddNewCategory.vue?vue&type=template&id=8b07a2e8"
import script from "./AddNewCategory.vue?vue&type=script&lang=js"
export * from "./AddNewCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__